export default "__VITE_ASSET__6f76c7bf__"